import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgLifeAccidentDiscoverServices2FidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#life-accident-discover-services-2-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M57 28.5C57 12.76 44.24 0 28.5 0S0 12.76 0 28.5 12.76 57 28.5 57 57 44.24 57 28.5"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: `life-accident-discover-services-2-fidelity-low_svg__b-${id}`,
        width: 57,
        height: 57,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: 'alpha'
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M57 28.5C57 12.76 44.24 0 28.5 0S0 12.76 0 28.5 12.76 57 28.5 57 57 44.24 57 28.5"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: `url(#life-accident-discover-services-2-fidelity-low_svg__b-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#AFDCDF",
        d: "M15.19 49.43c-7.478 0-11.186-5.057-6.3-13.36h41.42c5.211 3.336-1.563 7.528-12.349 7.528S23.345 49.43 15.19 49.43"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8C3DD",
        d: "M24.97 4.995h-.054v-.036c0-1.264-1.252-2.287-2.798-2.287-1.311 0-2.406.737-2.712 1.73-.047 0-.09-.006-.137-.006-.954 0-1.73.67-1.73 1.494s.772 1.494 1.73 1.494c.522 0 .989-.2 1.303-.512.443.24.973.379 1.546.379q.277 0 .541-.046c.471.425 1.327.706 2.308.706 1.487 0 2.696-.655 2.696-1.458s-1.209-1.458-2.696-1.458z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M24.97 5.383h-.054v-.036c0-1.264-1.252-2.287-2.798-2.287-1.311 0-2.406.737-2.712 1.73-.047 0-.09-.006-.137-.006-.954 0-1.73.67-1.73 1.494s.772 1.494 1.73 1.494c.522 0 .989-.2 1.303-.512.443.24.973.379 1.546.379q.277 0 .541-.046c.471.424 1.327.706 2.308.706 1.487 0 2.696-.655 2.696-1.458 0-.804-1.209-1.458-2.696-1.458z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8C3DD",
        d: "m39.088 7.796.053.012.007-.03c.219-1.057 1.622-1.66 3.136-1.346 1.283.266 2.227 1.105 2.355 1.997.046.01.09.014.136.024.933.193 1.578.912 1.435 1.6-.143.69-1.016 1.094-1.953.9-.511-.107-.934-.368-1.187-.693a3.7 3.7 0 0 1-1.58.003 4 4 0 0 1-.522-.149c-.535.26-1.422.322-2.382.123-1.457-.302-2.526-1.095-2.387-1.767s1.436-.975 2.892-.673z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m39.088 8.184.053.012.007-.03c.219-1.058 1.622-1.66 3.136-1.346 1.283.266 2.227 1.105 2.355 1.997.046.01.09.014.136.024.933.193 1.578.912 1.435 1.6-.143.69-1.016 1.093-1.953.9-.511-.107-.934-.368-1.187-.693a3.7 3.7 0 0 1-1.58.003 4 4 0 0 1-.522-.149c-.535.26-1.422.322-2.382.123-1.457-.302-2.526-1.095-2.387-1.767s1.436-.975 2.892-.673z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7A9EBF",
        d: "M6.754 15.496c0 .778-.594 1.41-1.326 1.41.732 0 1.326.63 1.326 1.408 0-.778.594-1.409 1.326-1.409-.732 0-1.326-.63-1.326-1.409M11.479 12.18c0 1.099-.854 1.99-1.907 1.99 1.053 0 1.907.89 1.907 1.989 0-1.1.853-1.99 1.906-1.99-1.053 0-1.906-.89-1.906-1.989M12.804 18.148c0 .915-.705 1.657-1.575 1.657.87 0 1.575.742 1.575 1.658 0-.916.705-1.658 1.575-1.658-.87 0-1.575-.742-1.575-1.657"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#89B081",
        d: "M33.416 12.712c-1.099-.254-3.92-2.312-4.807-2.974a.33.33 0 0 0-.206-.066l-.06.002a.37.37 0 0 0-.216.073c-.945.703-3.716 2.715-4.794 2.964-2.368.55-4.18.507-5.105.423a.626.626 0 0 0-.68.62v8.028c0 4.196 1.825 8.017 4.686 9.812l5.885 3.691a.45.45 0 0 0 .474.001l5.924-3.692c2.86-1.795 4.685-5.615 4.685-9.812v-8.028a.62.62 0 0 0-.424-.589.6.6 0 0 0-.255-.03c-.926.084-2.739.126-5.107-.423"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C875B",
        d: "M32.712 14.057c-.945-.22-3.372-1.995-4.136-2.566a.3.3 0 0 0-.177-.057h-.051a.32.32 0 0 0-.186.064c-.813.606-3.198 2.343-4.126 2.558-2.037.474-3.596.437-4.392.365a.54.54 0 0 0-.585.534v6.926c0 3.62 1.57 6.917 4.031 8.466l5.064 3.185a.39.39 0 0 0 .407 0l5.097-3.185c2.462-1.548 4.032-4.845 4.032-8.466v-6.925a.534.534 0 0 0-.585-.534c-.795.072-2.355.108-4.393-.365"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m26.225 26.794-2.885-4.459 1.106-.814 1.946 3.007 6.297-7.05.974.988z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "m8.658 29.376-.967-6.762s2.284-1.757 3.338 8.255l-1.054.879z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "m10.845 31.345-2.116-6.81s1.95-2.185 4.713 7.958l-.889 1.079z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "M13.233 33.13 11.6 27.684s1.423-1.723 3.567 6.386l-.648.85z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        fillRule: "evenodd",
        d: "M25.75 50.3q-1.32 1.183-3.462 1.183t-3.39-1.182s1.003-5.993.828-6.52c-.167-.5-1.92-3.698-7.824-6.125l-.005-.002a3.2 3.2 0 0 1-1.521-1.302l-6.813-11.19s1.58-1.582 5.094 4.215l.87.87c.996.26 2.699 1.108 5.543 3.434 0 0 6.706 2.065 7.818 3.425.79.966 1.581 2.81 1.845 4.655z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "M15.07 37.018s-5.095-4.04-7.057-5.819c0 0 4.37 4.018 5.655 5.294a.96.96 0 0 0 .415.243z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "M8.014 31.2s-.68-1.968 2.222-.71c0 0-2.427-.894-2.222.71M20.165 50.988a4.6 4.6 0 0 1-.666-.297 8 8 0 0 1-.712-.447s1.114-5.937.939-6.464c-.167-.5-1.92-3.697-7.824-6.125.213.067 7.052 2.233 8.263 6.038zM48.24 29.376l.966-6.762s-2.284-1.757-3.338 8.255l1.054.879z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "m46.051 31.345 2.117-6.81s-1.95-2.185-4.713 7.958l.889 1.079z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "m43.665 33.13 1.633-5.446s-1.423-1.723-3.567 6.386l.647.85z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        fillRule: "evenodd",
        d: "M31.148 50.3q1.32 1.183 3.462 1.183 2.141 0 3.39-1.182s-1.004-5.993-.828-6.52c.167-.5 1.92-3.698 7.823-6.125l.005-.002a3.2 3.2 0 0 0 1.522-1.302l6.813-11.19s-1.581-1.582-5.095 4.215l-.87.87c-.996.26-2.698 1.108-5.542 3.434 0 0-6.706 2.065-7.818 3.425-.791.966-1.582 2.81-1.845 4.655z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "M41.827 37.018s5.095-4.04 7.057-5.819c0 0-4.371 4.018-5.655 5.294a.96.96 0 0 1-.416.243z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "M48.884 31.2s.68-1.968-2.222-.71c0 0 2.427-.894 2.222.71M36.733 50.988q.351-.125.666-.297.314-.171.711-.447s-1.114-5.937-.938-6.464c.167-.5 1.92-3.697 7.823-6.125-.212.067-7.052 2.233-8.262 6.038z",
        clipRule: "evenodd"
    }))), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `life-accident-discover-services-2-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgLifeAccidentDiscoverServices2FidelityLow;
